module.exports = __webpack_public_path__ + "img/snowflake.e9c0b49b.svg";